import { useField } from "formik";
import { EfsMelcoEfsModelsSchemaListItem } from "melco-shared-logic";

export const useDataAssignments = () => {
  const [{ value: schema_list }] =
    useField<EfsMelcoEfsModelsSchemaListItem[]>("schema_list");

  return schema_list ?? [];
};
